import styled, { createGlobalStyle } from 'styled-components';
import theme from 'styles/theme';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Roboto+Condensed:400,500,700');
`;

/* Hub Group Navigation */
const GroupNav = styled.nav`
  margin: 2.55rem 0 1.55rem;
  max-width: 400px;
  position: relative;

  h2 {
    border-bottom: 2px solid ${theme.black};
    color: ${theme.grayDarkest};
    font-size: 1rem !important; /* Overwrite Gutenberg */
    font-weight: 700 !important; /* Overwrite Gutenberg */
    padding-bottom: 0.75rem;
    margin-bottom: 0.1875rem;
    text-transform: uppercase;
  }

  .caret--input {
    appearance: none;
    background: transparent;
    border: 0;
    height: 20px;
    left: 0;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 100;

    &:checked + label {

      &::before {
        border-width: 0 4px 4px 0;
        top: 0;
      }
    }

    &:checked + label + ul {
      /* Force the browser to recognize this connection. */
      max-height: 1000px !important;
      opacity: 1;
    }
  }

  .caret {
    cursor: pointer;
    display: block;
    height: 20px;
    margin-left: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;

    @media (media('l-min')) {
      border-bottom: 1px solid $color-palette-light-gray;
      display: none;
    }

    &::before {
      border-radius: 3px;
      border-style: solid;
      border-width: 4px 0 0 4px;
      content: '';
      height: 10px;
      right: 0;
      pointer-events: none;
      position: absolute;
      top: 6px;
      transform: translateX(-50%) rotate(45deg);
      width: 10px;
    }
  }

  ul {
    border-bottom: 2px solid ${theme.black};
    display: flex;
    flex-flow: column wrap;
    margin: 0 !important; /* Override Gutenberg */
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    padding: 0.8rem 0 0.1rem !important; /* Override Gutenberg */
    transition: max-height 0.3s, opacity 0.3s ease-in-out;

    li {
      margin-bottom: 0.8rem !important; /* Override Gutenberg */

      a {
        color: ${theme.black};
        display: inline-block;
        font-weight: 700;
        font-size: 0.9rem;
        hyphens: auto;
        line-height: 1;
        margin-right: 5px;
        width: 100%;

        &:hover,
        &:focus {
          text-decoration: underline;
        }
      }
    }
  }
`;

export default {
  GlobalStyles,
  GroupNav,
};
